export default "__VITE_ASSET__Pp1J7UK0__"